<template>
  <div style="overflow:auto">
    <md-card>
      <md-card-header>
        <div class="md-title">Sync Stores from SAP</div>
      </md-card-header>

      <md-card-content/>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="syncStores">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

      <md-card>
      <md-card-header>
        <div class="md-title">Sync Location from SAP</div>
      </md-card-header>

      <md-card-content/>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="syncLocation">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

      <md-card>
      <md-card-header>
        <div class="md-title">Sync IBS List from SAP</div>
      </md-card-header>

      <md-card-content/>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="syncIBSList">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

      <md-card>
      <md-card-header>
        <div class="md-title">Sync Terminal from SAP</div>
      </md-card-header>

      <md-card-content/>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="syncTerminal">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

    <hr class="solid"/>

    <div id="triggerElm" onload="window.alert('test');this.setAutoScroll()">
    <md-card>
      <md-card-header>
        <div class="md-title">Trigger Save Load</div>
      </md-card-header>

      <md-card-content>
        <md-field>
          <label>Driver Id</label>
          <md-input v-model="saveLoadRequest.driverId"/>
        </md-field>
        <md-field>
          <label>Load Id</label>
          <md-input v-model="saveLoadRequest.loadIdAssigned"/>
        </md-field>
      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="saveLoad">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Trigger Save BOL</div>
      </md-card-header>

      <md-card-content>
        <md-field>
          <label>Load Id</label>
          <md-input v-model="saveBillOfLoadRequest.loadIdUsed"/>
        </md-field>
        <md-field>
          <label>BOL Id</label>
          <md-input v-model="saveBillOfLoadRequest.id"/>
        </md-field>
      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="saveBillOfLoad">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Trigger BOL Extra Cost</div>
      </md-card-header>

      <md-card-content>
        <md-field>
          <label>Load Id</label>
          <md-input v-model="saveBillOfLoadExtraCostRequest.loadIdUsed"/>
        </md-field>
        <md-field>
          <label>BOL Id</label>
          <md-input v-model="saveBillOfLoadExtraCostRequest.id"/>
        </md-field>
      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="saveBillOfLoadExtraCost">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Trigger Yard QC Confirm</div>
      </md-card-header>

      <md-card-content>
        <md-field>
          <label>Problem Id</label>
          <md-input v-model="saveYardQcRequest.problemId"/>
        </md-field>
        <md-field>
          <label>Load Id</label>
          <md-input v-model="saveYardQcRequest.loadId"/>
        </md-field>
      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="triggerYardQcConfirm">Execute</md-button>
        </calling-api>
      </md-card-actions>

    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Trigger Outbound</div>
      </md-card-header>

      <md-card-content>
        <md-field>
          <label>User</label>
          <md-input v-model="outboundRequest.user"/>
        </md-field>
        <md-field>
          <label>Seq No.</label>
          <md-input v-model="outboundRequest.seqNo"/>
        </md-field>
      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="saveOutbound">Execute</md-button>
        </calling-api>
      </md-card-actions>

    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Trigger SaveInbound test</div>
      </md-card-header>

      <md-card-content/>

      <md-card-actions>
        <calling-api path="/api/w/sqs/send" :not-display-error="true">
          <md-button @click="triggerInbound">Execute</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>  

    </div>

  </div>


</template>

<style lang="scss" scoped>
  .md-card {
    width: 380px;
    margin: 8px;
    display: inline-block;
    vertical-align: top;
  }
</style>

<script>
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  export default {
    data: () => ({
      data: [],
      saveLoadRequest: {
        driverId: null,
        loadIdAssigned: null,
      },
      saveBillOfLoadRequest: {
        loadIdUsed: null,
        id: null,
      },
      saveBillOfLoadExtraCostRequest: {
        loadIdUsed: null,
        id: null,
      },
      saveYardQcRequest:{
        problemId: null,
        loadId: null,
      },
      outboundRequest:{
        user: null,
        seqNo: null
      },
      saveOutboundRequest: [
         { 
           user: null ,
           seqNo: null 
         }
      ]
      
    }),

    methods: {
      syncStores() {
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SYNC_STORES",
          payload: null,
        })
      },
      syncLocation() {
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SYNC_LOCATION",
          payload: null,
        })
      },
      syncTerminal() {
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SYNC_TERMINAL",
          payload: null,
        })
      },
      syncIBSList() {
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SYNC_IBSLIST",
          payload: null,
        })
      },

      saveLoad() {
        if (!this.saveLoadRequest.loadIdAssigned || !this.saveLoadRequest.driverId) {
          window.alert('Please input load Id and driver Id');
          return;
        }
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SAVE_LOAD",
          payload: JSON.stringify(this.saveLoadRequest),
        })
      },
      saveBillOfLoad() {
        if (!this.saveBillOfLoadRequest.id || !this.saveBillOfLoadRequest.loadIdUsed) {
          window.alert('Please input load Id and BOL Id');
          return;
        }
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SAVE_BOL",
          payload: JSON.stringify(this.saveBillOfLoadRequest),
        })
      },
      saveBillOfLoadExtraCost() {
        if (!this.saveBillOfLoadExtraCostRequest.id || !this.saveBillOfLoadExtraCostRequest.loadIdUsed) {
          window.alert('Please input load Id and BOL Id');
          return;
        }
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "BOL_EXTRA_COST",
          payload: JSON.stringify(this.saveBillOfLoadExtraCostRequest),
        })
      },
      saveOutbound() {
//        if (!this.outboundRequest.user || !this.outboundRequest.seqNo) {
//        //  window.alert('Please input User and Seq No.');
//        //  return;
//           this.outboundRequest.user = ""
//           this.outboundRequest.seqNo = ""
//        }
        //this.saveOutboundRequest = {containerInfo:[{user:this.outboundRequest.user,seqNo:this.outboundRequest.seqNo}]};

        console.log(JSON.stringify(this.outboundRequest));
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SAVE_OUTBOUND",
          payload: JSON.stringify(this.outboundRequest),
        })
      },
      triggerYardQcConfirm(){
        if (!this.saveYardQcRequest.problemId || !this.saveYardQcRequest.loadId) {
          window.alert('Please input load Id and problem Id');
          return;
        }
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "EXTRA_COST",
          payload: JSON.stringify(this.saveYardQcRequest),
        })
      },
      triggerInbound() {
        //api.post('/api/w/sqs/send', {
        newAPIPost('/api/w/sqs/send', {
          cmd: "SAVE_INBOUND",
          payload: null,
        })
      },
      showMessage(){
        window.alert("test");
      },
      setAutoScroll(){
        window.setInterval(function() {
           window.alert(document.getElementById('triggerElm'));
           var elem = document.getElementById('triggerElm');
               elem.scrollTop = elem.scrollHeight;
        }, 5000);
      }
    }
  }
</script>
